"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LeadGenSkeleton;
var _react = _interopRequireDefault(require("react"));
var _core = require("@linaria/core");
var _box = _interopRequireDefault(require("@ux/box"));
var _skeleton = _interopRequireDefault(require("@ux/skeleton"));
const boxStyles = "pl-ba67w34";
const bigSkeleton = "pl-b8bi85";
function LeadGenSkeleton() {
  return /*#__PURE__*/_react.default.createElement(_box.default, {
    blockAlignChildren: 'center',
    className: boxStyles,
    "data-testid": "lead-gen-skeleton",
    gap: "lg"
  }, /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: "lg"
  }, /*#__PURE__*/_react.default.createElement(_box.default, null, /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    width: "100%",
    rounding: "default",
    className: bigSkeleton
  })), /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "lg",
    width: "25%",
    rounding: "default"
  })), /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: "md"
  }, /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "2xl",
    width: "100%",
    rounding: "default"
  }), /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "2xl",
    width: "100%",
    rounding: "default"
  }), /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "2xl",
    width: "100%",
    rounding: "default"
  }), /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "xl",
    width: "20%",
    rounding: "default"
  }), /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "xl",
    width: "10%",
    rounding: "default"
  }), /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    size: "lg",
    width: "40%",
    rounding: "default"
  })));
}